/* eslint-disable react/forbid-dom-props */
import { ReactNode } from "react";

import Button from "@vfuk/core-button/";
import Spacing from "@vfuk/core-spacing";

import "../../assets/styles/common.scss";
import classes from "./DiscardModalContent.module.scss";

export type DiscardModalContentProps = {
  heading?: string;
  message: string;
  body: string | ReactNode;
  confirmMessage: string;
  onConfirm: () => void;
  cancelMessage?: string;
  onCancel?: () => void;
  loading?: boolean;
  discardButtonAlign?: boolean;
  changedStatus?: string;
  previousStatus?: string;
};

const getColor = (state: string) => {
  switch (state.toLowerCase()) {
    case "submitted":
      return "rgb(235, 151, 0)";
    case "accepted":
      return "rgb(0, 124, 146)";
    case "cancelled":
      return "rgb(189, 0, 0)";
    default:
      return "rgb(190, 190, 190)";
  }
};

export const DiscardModalContent = (
  props: DiscardModalContentProps
): JSX.Element => {
  return (
    <>
      <div className={classes.DiscardModalContents} role="dialog">
        {props.heading && <div className="modalHeading">{props.heading}</div>}
        {props.previousStatus && props.changedStatus && (
          <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
            <div className="modalMessage">
              {props.message}
              <span style={{ color: getColor(props.previousStatus) }}>
                {props.previousStatus}
              </span>{" "}
              to{" "}
              <span style={{ color: getColor(props.changedStatus) }}>
                {props.changedStatus}
              </span>
            </div>
          </Spacing>
        )}
        {!props.previousStatus && !props.changedStatus && (
          <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
            <div className="modalMessage">{props.message}</div>
          </Spacing>
        )}
        <Spacing spacingLevel={{ top: 3, bottom: 5 }}>
          <div className="modalSubmessage">{props.body}</div>
        </Spacing>
        <br />
        <div className={classes.Buttons}>
          {props.cancelMessage && (
            <div className={(classes.Button, classes.cancelButton)}>
              <Button
                width="auto"
                text={props.cancelMessage}
                onClick={props.onCancel}
              />
            </div>
          )}
          <div className={(classes.Button, classes.confirmButton)}>
            <Button
              width="auto"
              appearance="alt1"
              text={props.confirmMessage}
              onClick={props.onConfirm}
              loading={props.loading}
            />
          </div>
        </div>
      </div>
    </>
  );
};
